<template>
  <v-card rounded="lg" class="planning-technicien">
    <v-card-title class="pa-4 d-flex align-center" style="background:#E8EAF6">
      <v-icon color="#3F51B5" class="mr-2">mdi-account-switch-outline</v-icon>
      <span style="font-size:15px; font-weight:700">Changement de technicien</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pa-4">
      <div style="font-size:14px; line-height:1.6; margin-bottom:12px">
        L'intervention <strong>{{ data.num }}</strong> est attribuée à
        <v-chip size="small" color="#3F51B5" style="color:white; margin:0 4px">{{ data.eventTech.join(" / ") }}</v-chip>
        Voulez-vous l'attribuer à
        <v-chip size="small" color="success" style="color:white; margin:0 4px">{{ selectedTechniciens.join(" / ") }}</v-chip> ?
      </div>

      <div v-if="planningSettings['multie-technicien']">
        <v-btn
          variant="tonal"
          color="#3F51B5"
          class="mb-3"
          size="small"
          @click="setTech([...data.eventTech])"
        >
          <v-icon size="16" class="mr-1">mdi-account-check</v-icon>
          Réassigner au(x) technicien(s) d'origine :
          <strong class="ml-1">{{ data.eventTech.join(" / ") }}</strong>
        </v-btn>

        <div style="border:1px solid #E0E0E0; border-radius:8px; padding:12px">
          <div style="font-weight:600; font-size:13px; margin-bottom:8px; color:#424242">
            <v-icon size="16" class="mr-1">mdi-account-group-outline</v-icon>
            Sélectionner le(s) technicien(s) :
          </div>
          <v-text-field
            v-model="filters"
            placeholder="Rechercher..."
            density="compact"
            variant="outlined"
            hide-details
            clearable
            prepend-inner-icon="mdi-magnify"
            class="mb-2"
          ></v-text-field>
          <div style="overflow-y:auto; max-height:200px; border:1px solid #E0E0E0; border-radius:6px; padding:4px">
            <v-list density="compact" class="pa-0">
              <v-list-item
                v-for="tech in technicienListToShow"
                :key="tech.id"
                @click="addTech(tech.title)"
                :active="selectedTechniciens.includes(tech.title)"
                active-color="#3F51B5"
                rounded="sm"
                style="cursor:pointer"
              >
                <template v-slot:prepend>
                  <v-checkbox-btn
                    :model-value="selectedTechniciens.includes(tech.title)"
                    color="#3F51B5"
                    density="compact"
                  ></v-checkbox-btn>
                </template>
                <v-list-item-title style="font-size:13px">{{ tech.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn variant="text" @click="closeModal">
        <v-icon class="mr-1" size="18">mdi-close</v-icon>Non
      </v-btn>
      <v-btn color="success" variant="flat" style="color:white" @click="saveModal">
        <v-icon class="mr-1" size="18">mdi-check</v-icon>Oui, attribuer
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      filters: "",
      selectedTechniciens: [],
    };
  },
  props: {
    data: {},
    planningSettings: {},
    technicienList: {},
  },
  mounted() {
    this.selectedTechniciens = [...this.data.calendarTech];
  },
  computed: {
    technicienListToShow() {
      let techList = this.technicienList;
      techList = techList.sort(function (a, b) {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      });

      if (this.filters == "") {
        return techList;
      } else {
        let filteredTech = [];
        for (let i = 0; i < techList.length; i++) {
          if (techList[i].id.toLowerCase().includes(this.filters.toLowerCase()))
            filteredTech.push(techList[i]);
        }
        return filteredTech;
      }
    },
  },
  methods: {
    setTech(techList) {
      this.selectedTechniciens = techList;
    },
    addTech(tech) {
      if (this.selectedTechniciens.includes(tech)) {
        let index = this.selectedTechniciens.findIndex((val) => val == tech);
        this.selectedTechniciens.splice(index, 1);
      } else {
        this.selectedTechniciens.push(tech);
      }
    },
    closeModal() {
      this.$emit("close");
    },
    saveModal() {
      this.$emit("save", {
        e: this.data.e,
        Techniciens_Nom: this.selectedTechniciens,
      });
    },
  },
};
</script>

<style>
</style>